import { marcaBlancaApiClient as client, createAxiosInstanceWithStore } from '../client';
import { marcaBlancaApi } from './endpoints';

export default {
  initApp(appId, store) {
    let thisClient = client;
    if (store) thisClient = createAxiosInstanceWithStore(store);
    return thisClient.get(marcaBlancaApi.getAppInitialDataBySeccions(appId));
  },
  /**
   * params type -> {empresaId: number, seccionId:number, esDefault: boolean}
   * @param params
   * @return {*}
   */
  getBanners(params) {
    return client.get(marcaBlancaApi.getBannersBySections(), params);
  },
  getCustomSection(id) {
    return client.get(marcaBlancaApi.getCustomSectionById(id));
  },
  getDefaultSection(id) {
    return client.get(marcaBlancaApi.getDefaultSectionById(id));
  },
  getTemplate(appId, store) {
    let thisClient = client;
    if (store) thisClient = createAxiosInstanceWithStore(store);
    return thisClient.get(marcaBlancaApi.getTemplateData(appId));
  },
  getMeasurementIntegrations(appId, store) {
    let thisClient = client;
    if (store) thisClient = createAxiosInstanceWithStore(store);
    return thisClient.get(marcaBlancaApi.getMeasurementIntegrations(appId));
  },
  getSeccionLanding(id, appId, store) {
    let thisClient = client;
    if (store) thisClient = createAxiosInstanceWithStore(store);
    return thisClient.get(marcaBlancaApi.getSeccionLanding(id, appId));
  },
};
